/**
 * React hook to handle success with snackbar
 */

import { useEffect } from 'react';

import useSnackbar from './useSnackbar';

const useSuccess = (isSuccess: boolean | undefined,
  successMessage: string,
  onSuccess?: () => void) => {
  const createSnackbar = useSnackbar();
  useEffect(() => {
    if (isSuccess) {
      createSnackbar(successMessage, 'success');
      if (onSuccess) onSuccess();
    }
  }, [isSuccess]);
};

export default useSuccess;
